module.exports = __webpack_public_path__ + "img/Regatta_Group-Logo.e250cce8.svg";